import type { BalanceDisplayRow } from './balance-drafts'

export const getBalanceStatus = (row: BalanceDisplayRow) => {
  if (row.override) return row.stale ? 'REVIEW REQUIRED' : 'PENDING'
  if (row.is_manual) return 'SAVED MANUAL'
  if (row.is_saved) return 'SAVED'
  return 'PREVIEW'
}
